import * as React from "react"
import { List, Set } from "immutable"
import { ApiResult, getActivities, getDatesForPeriod } from "../../custom_api/api"
import { ActivitySummaryProps } from "./activity_summary"
import { makeOpt, emptyOpt } from "../../custom_utils/option"
import { ActivityCluster } from "./activity_cluster"

export type ActivityClusterBlockProps = {
  readonly title: string
  readonly slug: string
  readonly description: string
  readonly row_count: number
  readonly activitySummariesIds: List<number>
}

export type ActivityClusterBlockState = {
  activitySummaries: ApiResult<List<ActivitySummaryProps>>
}

export class ActivityClusterBlock extends React.Component<ActivityClusterBlockProps, ActivityClusterBlockState> {
  constructor(props: ActivityClusterBlockProps) {
    super(props)

    this.state = {
      activitySummaries: "loading",
    }
  }

  componentDidMount() {
    getActivities({
      cluster: emptyOpt(),
      activity: makeOpt(q =>
        q.Where(q => {
          let exp = q.Id.Equals(0)
          this.props.activitySummariesIds.forEach(id => (exp = exp.Or(q.Id.Equals(id))))
          return exp
        })
      ),
      edition: emptyOpt(),
      location: emptyOpt(),
      region: emptyOpt(),
      event: makeOpt(q =>
        q.Where(e => {
          let period = getDatesForPeriod("any")
          return e.Date.IsAfter(period.start.toDate()).And(e.Date.IsBefore(period.end.toDate()))
        })
      )
    }).then(res => {
      if (res != "error" && res !== "loading") {
        this.setState(s => ({
          ...s,
          activitySummaries: res,
        }))
      }
    })
  }

  render() {
    return (
      <ActivityCluster
        activitySummaries={
          this.state.activitySummaries != "error" && this.state.activitySummaries != "loading"
            ? this.state.activitySummaries
            : List()
        }
        title={this.props.title}
        description={this.props.description}
        row_count={this.props.row_count}
        slug={"abc"}
      />
    )
  }
}
